import "./Login.css";
import React from "react";
import LoginAuth0 from "./LoginAuth0";

export default function LoginButton() {
  return (
    <>
      <LoginAuth0 />
    </>
  );
}